import { useCallback } from 'react';
import { useAuthenticatedFetch } from './useAuthenticatedFetch';
import { useAppToast } from './useAppToast';

/** Inicia o login do Instagram (a volta cai em Ferramentas › Instagram) */
export function useInstagramConnect() {
  const fetchApi = useAuthenticatedFetch();
  const toast = useAppToast();
  return useCallback(async () => {
    const res = await fetchApi('/api/tools/instagram/connect');
    const j = await res.json().catch(() => ({}));
    if (!res.ok) { toast.error(j.message || 'Não foi possível iniciar a conexão'); return; }
    window.location.href = j.url;
  }, [fetchApi, toast]);
}
